export const USER_PREFERENCE_KEYS = {
  ONLY_SHOW_USER_CHANGES: 'only_show_user_changes',
} as const;

export type UserPreferenceKey =
  (typeof USER_PREFERENCE_KEYS)[keyof typeof USER_PREFERENCE_KEYS];

export const isValidPreferenceKey = (key: string): key is UserPreferenceKey => {
  return Object.values(USER_PREFERENCE_KEYS).includes(key as UserPreferenceKey);
};
